import { useState, type FunctionComponent } from 'react';
import { Navigate } from 'react-router-dom';
import Survey from '../survey/Survey';

const TRIAL_MEMBERS_INTRO_TEXT = `
  Fill out your Personal Survey so we can get to know you better!
  Your participation helps our team to understand what you and other members want to see in future boxes.
  Please note, this survey is not currently used to customize your boxes.
`;

const TrialMembers: FunctionComponent = () => {
  const [redirect, setRedirect] = useState(false);

  const afterLastButton = () => setRedirect(true);

  return redirect ? (
    <Navigate to="/trial-survey/confirm" replace />
  ) : (
    <Survey
      welcomeText={TRIAL_MEMBERS_INTRO_TEXT}
      afterLastButton={afterLastButton}
      shouldStopTimer={false}
      isNewMember={false}
    />
  );
};

export default TrialMembers;
